import { currencyOptions } from 'atoms/StatusSelect/CurrencyStatusSelect';
import { invoiceTypeOptions } from 'atoms/StatusSelect/InvoiceTypeSelect';
import { contractTypeFilters } from 'utils/constants/common';
import { sortOptions } from 'utils/constants/invoiceStatus';
import { IFilterOption, IFilterOptionItem } from 'organisms/Filter/types';
import { fetchInvoiceProjects } from './invoiceProjects';

export type InvoiceComplexFilterValue = {
  invoice_date?: [Date | null, Date | null];
  project_ids?: string[];
  invoice_status?: string[];
  currency?: string[];
  invoice_type?: string[];
  contract_type?: string[];
};

export type MappedInvoiceFilters = {
  dateRange: [Date | null, Date | null];
  projectIds: string;
  status: string;
  currency: string;
  invoiceType: string;
  contractType: string;
};

const localList =
  (items: IFilterOptionItem[]) => async (): Promise<IFilterOptionItem[]> =>
    items;

const invoiceDateOption: IFilterOption = {
  code: 'invoice_date',
  title: 'Invoice date',
  active: true,
};

export const projectsOption: IFilterOption = {
  code: 'project_ids',
  title: 'Projects',
  fetchList: fetchInvoiceProjects,
};

const invoiceStatusOption: IFilterOption = {
  code: 'invoice_status',
  title: 'Invoice status',
  fetchList: localList(
    sortOptions.map(({ key, value }) => ({ id: value, name: key }))
  ),
};

const currencyOption: IFilterOption = {
  code: 'currency',
  title: 'Currency',
  selectionMode: 'single',
  fetchList: localList(
    currencyOptions.flatMap(({ label, values }) =>
      values.map(({ label: currency, value }) => ({
        id: value,
        name: `${currency} | ${label}`,
      }))
    )
  ),
};

const invoiceTypeOption: IFilterOption = {
  code: 'invoice_type',
  title: 'Invoice type',
  fetchList: localList(
    invoiceTypeOptions.map(({ key, value }) => ({ id: value, name: key }))
  ),
};

export const contractTypeOption: IFilterOption = {
  code: 'contract_type',
  title: 'Contract type',
  fetchList: localList(contractTypeFilters),
};

export const getInvoiceFilterOptions = (isAdmin: boolean): IFilterOption[] => [
  invoiceDateOption,
  // projectsOption,
  invoiceStatusOption,
  ...(isAdmin ? [currencyOption] : []),
  invoiceTypeOption,
  // contractTypeOption,
];

const mapStatuses = (selected: string[] = []) =>
  Array.from(
    new Set(
      selected
        .flatMap((status) => status.split(','))
        .map((status) => (status === 'pending' ? 'payment_pending' : status))
    )
  ).join(',');

export const mapInvoiceFilters = (
  value: InvoiceComplexFilterValue
): MappedInvoiceFilters => ({
  dateRange:
    value.invoice_date?.[0] && value.invoice_date?.[1]
      ? value.invoice_date
      : [null, null],
  projectIds: value.project_ids?.join(',') || '',
  status: mapStatuses(value.invoice_status) || 'all',
  currency: value.currency?.[0] || 'all',
  invoiceType: value.invoice_type?.join(',') || '',
  contractType: value.contract_type?.join(',') || '',
});
